var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lay_content_all"}},[_c('lay-left'),_c('div',{staticClass:"lay_content_all"},[_c('router-view')],1),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.showBgmusic)?_c('bg-music'):_vm._e()],1),_c('lay-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }